function slider() {
  [...document.querySelectorAll('.slider-wrapper .splide')]?.forEach(slider => {
    let splideInstance;
    const wrapper = slider.closest('.slider-wrapper');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    const initSlider = () => {
      const windowWidth = window.innerWidth;
      const type = windowWidth < 1024 ? 'fade' : 'slide';

      const isLogos = () => slider.classList.contains('logos');

      if (splideInstance) {
        splideInstance.destroy();
      }

      const defaultOptions = {
        type: type,
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        easing: 'linear',
        breakpoints: {
          1024: {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
            fixedWidth: '54.6875rem',
            autoplay: false,
            rewind: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
          },
          1366: {
            fixedWidth: '65.875rem',
          }
        },
      }

      const logosOptions = {
        type: 'fade',
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage:1,
        perMove: 1,
        focus: 'center',
        gap: 0,
        interval: 7000,
        rewind: true,
        height: '4.125rem',
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        mediaQuery: 'min',
        destroy: wrapper.closest('.wp-admin') != null,
        breakpoints: {
          1024: {
              destroy: true
          }
        }
      }

      splideInstance = new Splide(slider, isLogos() ? logosOptions: defaultOptions );

      splideInstance.on( 'move', function (newIndex, prevIndex, destIndex) {
        const slides = slider.querySelectorAll('.splide__slide');
        const direction = (newIndex > prevIndex) ? 'right' : 'left';
          
        slides.forEach(function(splideInstance, index) {
          if (index < destIndex) {
            splideInstance.classList.add('fade-out');
          } else {
            splideInstance.classList.remove('fade-out');
          }
        });
      });

      splideInstance.mount();
    };
    
    initSlider();
    window.addEventListener('resize', initSlider);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  slider();
});
